module.exports = __webpack_public_path__ + "assets/0275bd5ef1b09dce5658b812974b7958.svg";